import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";

export interface ChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
  children: ReactNode;
}

/** Filter chip — DESIGN.md §9. Selected = primary-soft bg + primary-text. */
export function Chip({ selected = false, className, children, ...props }: ChipProps) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      className={cn(
        "inline-flex h-6 items-center rounded-sm border px-3 text-small transition-colors focus-visible:outline-2 focus-visible:outline-primary",
        selected
          ? "border-primary bg-primary-soft text-primary-text"
          : "border-border bg-surface-2 text-text-secondary hover:border-border-strong hover:text-text-primary",
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
